import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

export const getGelombang = createAsyncThunk("reference/getGelombang", async() => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/gelombang`);
    return response.data;
});

export const getJalurPendaftaran = createAsyncThunk("reference/getJalurPendaftaran", async() => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/jalur_pendaftaran`);
    return response.data;
});

export const getSistemKuliah = createAsyncThunk("reference/sistemKuliah", async() => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/sistem/kuliah`);
    return response.data;
});

export const getJenisSeleksi = createAsyncThunk("reference/getJenisSeleksi", async() => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/jenis/seleksi`);
    return response.data;
});

export const getJenisSyarat = createAsyncThunk("reference/getJenisSyarat", async() => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/jenis/syarat`);
    return response.data;
});


export const getSyaratSeleksi = createAsyncThunk("reference/getSyaratSeleksi", async() => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/syarat/seleksi`);
    return response.data;
});

export const getProdi = createAsyncThunk("reference/getProdi", async() => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/program-studi`);
    return response.data;
});

export const getPeriode = createAsyncThunk("reference/getPeriode", async() => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/periode`);
    return response.data;
});

export const getStatus = createAsyncThunk("reference/getStatus", async() => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/status`);
    return response.data;
});

const initialState = {
    loading: false,
    gelombang: [],
    jalurPendaftaran: [],
    sistemKuliah: [],
    jenisSeleksi: [],
    jenisSyarat: [],
    syaratSeleksi: [],
    prodi: [],
    periode: [],
    status: []
}

const referenceSlice = createSlice({
    name:"reference",
    initialState: initialState,
    extraReducers: {

        [getStatus.pending] : (state, action) => {
            state.loading = true;
        },
        [getStatus.fulfilled] : (state, action) => {
            state.status = action.payload;
            state.loading = false;
        },
        [getStatus.rejected] : (state, action) => {
            state.loading = false;
        },

        [getSyaratSeleksi.pending] : (state, action) => {
            state.loading = true;
        },
        [getSyaratSeleksi.fulfilled] : (state, action) => {
            state.syaratSeleksi = action.payload;
            state.loading = false;
        },
        [getSyaratSeleksi.rejected] : (state, action) => {
            state.loading = false;
        },

        [getJenisSyarat.pending] : (state, action) => {
            state.loading = true;
        },
        [getJenisSyarat.fulfilled] : (state, action) => {
            state.jenisSyarat = action.payload;
            state.loading = false;
        },
        [getJenisSyarat.rejected] : (state, action) => {
            state.loading = false;
        },


        [getGelombang.pending] : (state, action) => {
            state.loading = true;
        },
        [getGelombang.fulfilled] : (state, action) => {
            state.gelombang = action.payload;
            state.loading = false;
        },
        [getGelombang.rejected] : (state, action) => {
            state.loading = false;
        },

        [getJalurPendaftaran.pending] : (state, action) => {
            state.loading = true;
        },
        [getJalurPendaftaran.fulfilled] : (state, action) => {
            state.jalurPendaftaran = action.payload;
            state.loading = false;
        },
        [getJalurPendaftaran.rejected] : (state, action) => {
            state.loading = false;
        },

        [getSistemKuliah.pending] : (state, action) => {
            state.loading = true;
        },
        [getSistemKuliah.fulfilled] : (state, action) => {
            state.sistemKuliah = action.payload;
            state.loading = false;
        },
        [getSistemKuliah.rejected] : (state, action) => {
            state.loading = false;
        },

        [getJenisSeleksi.pending] : (state, action) => {
            state.loading = true;
        },
        [getJenisSeleksi.fulfilled] : (state, action) => {
            state.jenisSeleksi = action.payload;
            state.loading = false;
        },
        [getJenisSeleksi.rejected] : (state, action) => {
            state.loading = false;
        },

        [getProdi.pending] : (state, action) => {
            state.loading = true;
        },
        [getProdi.fulfilled] : (state, action) => {
            state.prodi = action.payload;
            state.loading = false;
        },
        [getProdi.rejected] : (state, action) => {
            state.loading = false;
        },

        [getPeriode.pending] : (state, action) => {
            state.loading = true;
        },
        [getPeriode.fulfilled] : (state, action) => {
            state.periode = action.payload;
            state.loading = false;
        },
        [getPeriode.rejected] : (state, action) => {
            state.loading = false;
        },
    }
})

export const referenceSelector = (state) => state.reference;
export default referenceSlice.reducer;